import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function privateAlbumAdvanceReducer(state = initialState.privateAlbumsAdvance, action) {
  switch (action.type) {
    case types.GET_ALBUM_SUCCESS:
      const albumsAccess = action.privateAlbums.filter(album => album.isGranted || album.hasAccess);
      state = state.setIn(['byUserId', action.friendId], albumsAccess);
      //      console.log('fff friend', action.friendId);
      //      console.log('fff albumsAccess', albumsAccess);

      return state.set('numberUsers', Object.keys(state.byUserId).length).set('isLoading', false);
    case types.GET_ALBUM_REQUEST:
      return state.set('isLoading', true);
    case types.GET_ALBUM_FAILED:
      return state.set('isLoading', false);
    case types.ADD_GRANTED_ALBUM:
      const oldAlbumData = [...(state.byUserId[action.friendId] || [])];
      return state.setIn(['byUserId', action.friendId], [...oldAlbumData, ...action.privateAlbums]);
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.privateAlbumsAdvance;
      return state;
    }
    default:
      return state;
  }
}
